module.exports = __webpack_public_path__ + "sk.e995322e.svg";